<script setup>
import { computed } from 'vue'

const props = defineProps({
  teamId: {
    type: String,
    default: ''
  },
  alterText: {
    type: String,
    default: ''
  }
})

const teamShortName = computed(() => {
  const teamId = (props.teamId ?? '').toString()
  if (!teamId) return ''

  try {
    const teams = JSON.parse(localStorage.getItem('teams') || '{}')
    const team = teams?.[teamId]
    return (team?.short_name ?? '').toString()
  } catch (e) {
    return ''
  }
})

const isSelectedTeam = computed(() => {
  const teamId = (props.teamId ?? '').toString()
  if (!teamId) return false

  try {
    const filterTeamId = JSON.parse(localStorage.getItem('filterConditionTeam') || '""')
    return filterTeamId === teamId
  } catch (e) {
    return false
  }
})
</script>

<template>
  <template v-if="teamShortName">
    <span class="timetable-team-label" :class="{ 'timetable-team-label--selected': isSelectedTeam }">{{ teamShortName }}</span>
  </template>
  <template v-else>
    <span v-if="props.alterText" class="timetable-team-label timetable-team-label--placeholder">{{ props.alterText }}</span>
  </template>
</template>

<style scoped>
.timetable-team-label {
  display: inline-block;
  font-size: 0.75em;
  /* padding: 0.1em; */
  color: #fa8072;
  background: transparent;
  width: 45px;
  /* margin: 1px; */
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.timetable-team-label--placeholder {
  color: #d3d3d3;
}

.timetable-team-label--selected {
  font-weight: bold;
  background-color: salmon;
  color: white;
  display:inline-block;
}
</style>
